module.exports = __webpack_public_path__ + "fonts/iconfont.2064f258.ttf";